import { Button, useToast } from "@chakra-ui/react";
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";

const ExportExcel = ({
  excelData,
  fileName,
  title,
}: {
  excelData: any;
  fileName: any;
  title: string;
}) => {
  const toast = useToast();
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
    toast({
      title: "Template Download",
      description: "Template downloaded successfully",
      status: "success",
    });
  };

  return (
    <>
      <Button
        borderRadius={2}
        variant={"outline"}
        colorScheme="red"
        size="sm"
        fontSize={{
          lg: "12px",
          md: "12px",
          sm: "10px",
          base: "10px",
        }}
        onClick={() => {
          exportToExcel();
        }}
      >
        {title}
      </Button>
    </>
  );
};

export default ExportExcel;
